import * as React from "react";
const SvgFiRrChessKing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chess-king_svg__a)">
      <path
        fill="#062147"
        d="M23.328 10.222a5.04 5.04 0 0 0-3.27-2.389A40 40 0 0 0 13 7.014V5h2a1 1 0 1 0 0-2h-2V1a1 1 0 1 0-2 0v2H9a1 1 0 0 0 0 2h2v2.014a40 40 0 0 0-7.058.819A5 5 0 0 0 .249 14.27L3.089 22h-.09a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-.088l2.855-7.774a5 5 0 0 0-.438-4.004m-1.453 3.358L18.78 22H5.219L2.14 13.624a3 3 0 0 1 2.23-3.838A38 38 0 0 1 12 9c2.563.005 5.119.269 7.629.786a3 3 0 0 1 1.971 1.437 2.95 2.95 0 0 1 .276 2.357"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chess-king_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChessKing;
